import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Search,
    Bell,
    HelpCircle,
    LogOut,
} from "lucide-react";

export default function Topbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = () => {
        setMenuOpen(false);
        // clear any stored auth/session data here if needed
        // e.g. localStorage.removeItem("token");
        navigate("/");
    };

    return (
        <header className="bg-white h-16 border-b flex items-center justify-between px-8">
            <div className="relative w-[450px]">
                <Search
                    size={18}
                    className="absolute left-4 top-4 text-gray-400"
                />

                <input
                    className="w-full pl-12 pr-4 py-3 rounded-xl bg-gray-100 outline-none"
                    placeholder="Search projects, machines, centres..."
                    style={{margin:"10px"}}
                />
            </div>

            <div className="flex items-center gap-6">
                <HelpCircle />
                <Bell />

                <div className="relative" ref={menuRef}>
                    <button
                        onClick={() => setMenuOpen((open) => !open)}
                        className="w-10 h-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold"
                    >
                        AR
                    </button>

                    {menuOpen && (
                        <div className="absolute right-0 mt-2 w-44 rounded-xl border border-gray-200 bg-white py-2 shadow-lg z-50">
                            <button
                                onClick={handleLogout}
                                className="flex w-full items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                            >
                                <LogOut className="h-4 w-4" />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}